import React, { useEffect, useRef } from "react";

const MapFooter = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const particles = [];
    const particleCount = 50;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        radius: Math.random() * 1.5 + 0.5,
        color: Math.random() > 0.5 ? '#0047AB' : '#00aeff'
      });
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < particles.length; i++) {
        const particle = particles[i];
        particle.x += particle.vx;
        particle.y += particle.vy;

        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        ctx.fillStyle = `${particle.color}40`;
        ctx.fill();
      }

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  const openInGoogleMaps = () => {
    window.open(
      "https://maps.app.goo.gl/R7UTxT64FmDYQeft6",
      "_blank"
    );
  };

  return (
    <footer className="map-footer">
      <canvas ref={canvasRef} className="background-canvas"></canvas>
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      <div className="container">
        <div className="footer-container">
          <div className="section-header">
            <h2 className="footer-heading">Visit Our Location</h2>
            <p className="footer-subtitle">Find us at the heart of Jodhpur's business district</p>
          </div>
          <div className="row mb-lg-0 mb-4">
            <div className="col-lg-8">
              <div className="map-section">
                <div className="map-container" onClick={openInGoogleMaps}>
                  <iframe
                    title="Blue City Mall Jodhpur"
                    src="https://www.google.com/maps?q=Blue+City+Mall+Jodhpur&output=embed"
                    loading="lazy"
                    allowFullScreen
                  ></iframe>

                  {/* Enhanced Hover Overlay */}
                  <div className="map-overlay">
                    <div className="overlay-content">
                      <svg className="map-icon" viewBox="0 0 24 24">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
                      </svg>
                      <p>Click to Open in Google Maps</p>
                      <span className="overlay-subtitle">Get directions to our office</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-card p-3 mb-4">
                <div className="card-icon">
                  <svg className="contact-icon" viewBox="0 0 24 24">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
                  </svg>
                </div>
                <div className="card-content">
                  <h3>Our Address</h3>
                  <p>203, Blue City Mall, Near Circuit House, Jodhpur, Rajasthan – 342006</p>
                </div>
              </div>

              <div className="contact-card p-3">
                <div className="card-icon">
                  <svg className="contact-icon" viewBox="0 0 24 24">
                    <path d="M6.62 10.79a15.91 15.91 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.36 11.36 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C9.61 21 2 13.39 2 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.36 11.36 0 0 0 .57 3.57 1 1 0 0 1-.25 1.02l-2.2 2.2z" />
                  </svg>
                </div>
                <div className="card-content">
                  <h3 className="mb-2">Contact Numbers</h3>
                  <div className="d-flex flex-wrap justify-content-center">
                    <a href="tel:+917742111480" className="phone-link d-inline-block fs-6 ps-0">+91-7742111480,</a>
                    <a href="tel:+918005885520" className="phone-link d-inline-block fs-6 ps-0">+91-8005885520,</a>
                    <a href="tel:+916378584647" className="phone-link d-inline-block fs-6 ps-0">+91-6378584647</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Call to Action */}
        <div className="cta-section">
          <h3>Ready to Go Solar?</h3>
          <p>Visit our showroom to explore our solar solutions and get expert consultation</p>
          <div className="cta-buttons">
            <button className="cta-btn primary" onClick={openInGoogleMaps}>
              <i className="fas fa-map-marker-alt"></i>
              Get Directions
            </button>
            <a href="tel:+918005885520" className="cta-btn secondary">
              <i className="fas fa-phone"></i>
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* ENHANCED STYLES */}
      <style>{`
        .map-footer {
          background: linear-gradient(135deg, #f8fbff 0%, #e6f2ff 50%, #d4e6ff 100%);
          padding: 100px 0;
          font-family: 'Poppins', sans-serif;
          position: relative;
          overflow: hidden;
          min-height: 80vh;
        }

        .background-canvas {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          pointer-events: none;
        }

        .floating-shapes {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }

        .shape {
          position: absolute;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(0,71,171,0.06) 0%, rgba(0,174,255,0.06) 100%);
          animation: float 30s infinite ease-in-out;
        }

        .shape-1 {
          width: 350px;
          height: 350px;
          top: -175px;
          right: -100px;
          animation-delay: 0s;
        }

        .shape-2 {
          width: 200px;
          height: 200px;
          bottom: -100px;
          left: -50px;
          animation-delay: 10s;
        }

        .shape-3 {
          width: 150px;
          height: 150px;
          top: 40%;
          left: -75px;
          animation-delay: 20s;
        }

        @keyframes float {
          0%, 100% { 
            transform: translateY(0) rotate(0deg) scale(1); 
          }
          33% { 
            transform: translateY(-40px) rotate(8deg) scale(1.1); 
          }
          66% { 
            transform: translateY(20px) rotate(-5deg) scale(0.9); 
          }
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .section-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .footer-heading {
          font-size: 3rem;
          color: #0047ab;
          margin-bottom: 15px;
          font-weight: 700;
          position: relative;
          display: inline-block;
        }

        .footer-heading::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #0047ab, #00aeff);
          border-radius: 2px;
        }

        .footer-subtitle {
          font-size: 1.2rem;
          color: #2c5282;
          margin: 0;
          line-height: 1.6;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin-bottom: 60px;
        }

        .contact-card {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
          padding: 35px;
          box-shadow: 0 15px 40px rgba(0,71,171,0.08);
          border: 1px solid rgba(0,71,171,0.1);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
          text-align: center;
        }

        .contact-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 25px 60px rgba(0,71,171,0.15);
          background: rgba(255, 255, 255, 1);
        }

        .card-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #0047ab 0%, #00aeff 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 25px;
          transition: all 0.3s ease;
        }

        .contact-card:hover .card-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .contact-icon {
          width: 20px;
          height: 20px;
          fill: #fff;
        }

        .card-content h3 {
          font-size: 1.4rem;
          color: #0047ab;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .card-content p {
          color: #4a5568;
          margin-bottom: 8px;
          line-height: 1.6;
        }

        .phone-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .phone-link {
          color: #00aeff;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.3s ease;
          padding: 5px 10px;
          border-radius: 8px;
        }

        .phone-link:hover {
          color: #0047ab;
          background: rgba(0,71,171,0.1);
          transform: translateX(5px);
        }

        .map-section {
          margin-bottom: 30px;
        }

        .map-title {
          font-size: 2rem;
          color: #0047ab;
          text-align: center;
          margin-bottom: 30px;
          font-weight: 600;
        }

        .map-container {
          position: relative;
          max-width: 1000px;
          height: 450px;
          margin: 0 auto;
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          box-shadow: 0 20px 60px rgba(0,71,171,0.15);
          transition: all 0.3s ease;
        }

        .map-container:hover {
          box-shadow: 0 30px 80px rgba(0,71,171,0.2);
        }

        .map-container iframe {
          width: 100%;
          height: 100%;
          border: 0;
          transition: all 0.3s ease;
        }

        .map-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(0,71,171,0.55) 0%, rgba(0,174,255,0.55) 100%);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: all 0.4s ease;
          pointer-events: none;
        }

        .map-container:hover .map-overlay {
          opacity: 1;
        }

        .overlay-content {
          text-align: center;
          transform: translateY(20px);
          transition: all 0.4s ease;
        }

        .map-container:hover .overlay-content {
          transform: translateY(0);
        }

        .map-icon {
          width: 60px;
          height: 60px;
          fill: #fff;
          margin-bottom: 15px;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        .map-overlay p {
          color: #fff;
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 8px;
        }

        .overlay-subtitle {
          color: rgba(255,255,255,0.9);
          font-size: 1rem;
        }

        .cta-section {
          text-align: center;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
          padding: 50px;
          box-shadow: 0 15px 40px rgba(0,71,171,0.08);
          border: 1px solid rgba(0,71,171,0.1);
          backdrop-filter: blur(10px);
        }

        .cta-section h3 {
          font-size: 2.2rem;
          color: #0047ab;
          margin-bottom: 15px;
          font-weight: 700;
        }

        .cta-section p {
          font-size: 1.1rem;
          color: #4a5568;
          margin-bottom: 35px;
          line-height: 1.6;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }

        .cta-buttons {
          display: flex;
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-btn {
          padding: 16px 32px;
          border-radius: 12px;
          font-size: 1.1rem;
          font-weight: 600;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          transition: all 0.3s ease;
          border: none;
          cursor: pointer;
          font-family: inherit;
        }

        .cta-btn.primary {
          background: linear-gradient(135deg, #0047ab 0%, #00aeff 100%);
          color: #fff;
        }

        .cta-btn.primary:hover {
          background: linear-gradient(135deg, #00aeff 0%, #0047ab 100%);
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(0,71,171,0.3);
        }

        .cta-btn.secondary {
          background: rgba(0,71,171,0.1);
          color: #0047ab;
          border: 2px solid #0047ab;
        }

        .cta-btn.secondary:hover {
          background: #0047ab;
          color: #fff;
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(0,71,171,0.3);
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .map-footer {
            padding: 80px 0;
          }
          
          .footer-heading {
            font-size: 2.5rem;
          }
          
          .contact-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 25px;
          }
          
          .contact-card {
            padding: 30px;
          }
        }

        @media (max-width: 768px) {
          .map-footer {
            padding: 60px 0;
          }
          
          .footer-heading {
            font-size: 2.2rem;
          }
          
          .footer-subtitle {
            font-size: 1.1rem;
          }
          
          .contact-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .contact-card {
            padding: 25px;
          }
          
          .map-container {
            height: 350px;
          }
          
          .cta-section {
            padding: 40px 25px;
          }
          
          .cta-buttons {
            flex-direction: column;
            align-items: center;
          }
          
          .cta-btn {
            width: 100%;
            max-width: 300px;
            justify-content: center;
          }
        }

        @media (max-width: 576px) {
          .map-footer {
            padding: 40px 0;
          }
          
          .footer-heading {
            font-size: 1.8rem;
          }
          
          .section-header {
            margin-bottom: 40px;
          }
          
          .contact-card {
            padding: 20px;
            border-radius: 15px;
          }
          
          .card-icon {
            width: 60px;
            height: 60px;
          }
          
          .contact-icon {
            width: 18px;
            height: 18px;
          }
          
          .map-container {
            height: 300px;
            border-radius: 15px;
          }
          
          .map-title {
            font-size: 1.6rem;
          }
          
          .cta-section {
            padding: 30px 20px;
            border-radius: 15px;
          }
          
          .cta-section h3 {
            font-size: 1.8rem;
          }
          
          .cta-btn {
            padding: 14px 24px;
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .footer-heading {
            font-size: 1.6rem;
          }
          
          .shape-1 {
            width: 200px;
            height: 200px;
            top: -100px;
            right: -50px;
          }
          
          .shape-2 {
            width: 120px;
            height: 120px;
            bottom: -60px;
            left: -30px;
          }
          
          .shape-3 {
            width: 100px;
            height: 100px;
            top: 30%;
            left: -50px;
          }
        }
      `}</style>
    </footer >
  );
};

export default MapFooter;
